export const localStorageRTTI = Symbol.for("localStorage");
export const clearCacheRTTI = Symbol.for("clearCache");
